import React from 'react';

const Button = (props) => {
    return <div className={props.type === 'white' ? "btn white" : "btn dark"} onClick={props.clicked}>
        {props.text}
    </div>
}

export default Button;